import { render, staticRenderFns } from "./Registrations.vue?vue&type=template&id=200df170&scoped=true&"
import script from "./Registrations.vue?vue&type=script&lang=js&"
export * from "./Registrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200df170",
  null
  
)

export default component.exports